import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./Charging.css";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Charging = () => {
  const { currentLang } = useContext(LanguageContext);
  const [charging, setCharging] = useState(null);
  const [loading, setLoading] = useState(true);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchCharging = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/ChargingSection?lang=${currentLang}`
        );
        setCharging(res.data);
      } catch (error) {
        console.error("Failed to fetch Charging section:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCharging();
  }, [currentLang]);

  if (loading || !charging) return null;

  return (
    <section className="charging-section">
      <div className="charging-image-wrapper">
        <img
          src={resolveUrl(charging.imageUrl)}
          alt={charging.title}
          loading="lazy"
        />

        <div className="charging-text">
          <h2>{charging.title}</h2>
          <p>{charging.description}</p>
        </div>
      </div>
    </section>
  );
};

export default Charging;
